import { render, staticRenderFns } from "./CommentBackModal.vue?vue&type=template&id=4bbd58f3&"
import script from "./CommentBackModal.vue?vue&type=script&lang=js&"
export * from "./CommentBackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports